export const CONFIRMATION_DIALOG__CANCEL_PAYOUT_REQUEST = 'CONFIRMATION_DIALOG__CANCEL_PAYOUT_REQUEST';
